import React from "react";
import pdf from "@react-pdf/renderer";
import { IIndexesByCategoryData } from "../../model/IndexesByCategoryData";
import OrganisationIndexHierarchyPDF from "./OrganisationIndexHierarchyPDF";
import ReportHeader from "./ReportHeader";
import { IOrganisationIndexCategory } from "../../../organisations/model/OrganisationIndexCategory";
import { DateFormats } from "../../../core/common/Constants";
import moment from "moment";

const { Page, Text, View } = pdf;
const IndexesByCategoryDataReportPDF = ({
  translate,
  data,
  styles,
  date,
  category
}: {
  translate: any;
  data: IIndexesByCategoryData;
  styles;
  date?: Date;
  category?: IOrganisationIndexCategory;
}) => {
  const renderReportingPeriods = () => {
    let reportingPeriods: JSX.Element[] = [];
    data.organisationIndexList?.forEach((item) => {
      reportingPeriods.push(
        <OrganisationIndexHierarchyPDF
          style={styles}
          indexHierarchyList={item.pathToIndex}
        />
      );
    });
    return reportingPeriods;
  };

  return (
    <Page size="A4" style={styles.body}>
      <ReportHeader
        translate={translate}
        title={`${translate("reports.indexes_by_category_data_report")} za ${
          data.organisation.name
        }`}
        otherParams={
          <View>
            {data.organisation.name && (
              <Text style={styles.subtitle}>{`${translate(
                "reports.organisation"
              )}: ${data.organisation.name}`}</Text>
            )}
            {date && (
              <Text style={styles.subtitle}>{`${translate(
                "reports.date"
              )}: ${moment(date).format(DateFormats.DATE)}`}</Text>
            )}
            {category && (
              <Text style={styles.subtitle}>{`${translate(
                "reports.category"
              )}: ${category.name}`}</Text>
            )}
            {data.institutionDetails.headquartersName && (
              <Text style={styles.subtitle}>{`${translate(
                "editors.organisations.institution_details.headquarters_name"
              )}: ${data.institutionDetails.headquartersName}`}</Text>
            )}
            {data.institutionDetails.institutionType && (
              <Text style={styles.subtitle}>{`${translate(
                "editors.organisations.institution_details.institution_type"
              )}: ${data.institutionDetails.institutionType}`}</Text>
            )}
            {data.institutionDetails.jurisdictionName && (
              <Text style={styles.subtitle}>{`${translate(
                "editors.organisations.institution_details.jurisdiction_name"
              )}: ${data.institutionDetails.jurisdictionName}`}</Text>
            )}
            {data.institutionDetails.jurisdictionType && (
              <Text style={styles.subtitle}>{`${translate(
                "editors.organisations.institution_details.jurisdiction_type"
              )}: ${data.institutionDetails.jurisdictionType}`}</Text>
            )}
          </View>
        }
      />

      {renderReportingPeriods()}
      <Text
        style={styles.pageNumbers}
        render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
        fixed
      />
    </Page>
  );
};

export default IndexesByCategoryDataReportPDF;
